import { Box, Button, useTheme } from '@mui/material';
import { Dayjs } from 'dayjs';
import { useIntl } from 'react-intl';

import { borderRadius } from '@verantos-dev/shared-ui-components/tokens';

import { StudyPeriodRestriction } from '../../StudyPeriodSection/StudyPeriodRestriction';

const noop = () => undefined;

type StudyPeriodInlineEditFormProps = {
  viewMode: boolean;
  isValidForSubmit: boolean;
  studyPeriodStartDate: Dayjs | null;
  setStudyPeriodStartDate: (value: Dayjs | null) => void;
  studyPeriodEndDate: Dayjs | null;
  setStudyPeriodEndDate: (value: Dayjs | null) => void;
  setHasDateBoundsError: (value: boolean) => void;
  minDateBound?: Dayjs;
  maxDateBound?: Dayjs;
  onSave: () => void;
  onCancel: () => void;
};

export const StudyPeriodInlineEditForm = ({
  viewMode,
  isValidForSubmit,
  studyPeriodStartDate,
  setStudyPeriodStartDate,
  studyPeriodEndDate,
  setStudyPeriodEndDate,
  setHasDateBoundsError,
  minDateBound,
  maxDateBound,
  onSave,
  onCancel,
}: StudyPeriodInlineEditFormProps) => {
  const intl = useIntl();
  const theme = useTheme();

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.cardBackground?.main,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: `${borderRadius.md}px`,
        px: theme.spacing(6),
        py: theme.spacing(4),
      }}
    >
      <StudyPeriodRestriction
        viewMode={viewMode}
        setHasDateBoundsError={setHasDateBoundsError}
        isStudyPeriodRestrictionEnabled
        setIsStudyPeriodRestrictionEnabled={noop}
        studyPeriodStartDate={studyPeriodStartDate}
        setStudyPeriodStartDate={setStudyPeriodStartDate}
        studyPeriodEndDate={studyPeriodEndDate}
        setStudyPeriodEndDate={setStudyPeriodEndDate}
        minDateBound={minDateBound}
        maxDateBound={maxDateBound}
        hideEnableCheckbox
      />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: theme.spacing(2),
          mt: theme.spacing(1),
        }}
      >
        <Button variant="outlined" size="small" onClick={onCancel} sx={{ textTransform: 'none' }}>
          {intl.formatMessage({
            id: 'projects.cohortBuilderPage.studyPeriodSection.cancelBtnCancel',
          })}
        </Button>
        <Button
          variant="contained"
          size="small"
          onClick={onSave}
          disabled={!isValidForSubmit}
          sx={{ textTransform: 'none' }}
        >
          {intl.formatMessage({
            id: 'projects.cohortBuilderPage.studyPeriodSection.saveBtn',
          })}
        </Button>
      </Box>
    </Box>
  );
};
